<template>
  <div class="page-header" >
    <div
      class="page-header-image"
      style="background-image: url('img/street-map.jpg')"
    ></div>
    <div class="content">
      <div class="container">
        <div class="col-md-5 ml-auto mr-auto" style="margin-top: 100px">
          <card class="card-signup" header-classes="text-center" color="orange">
            <template slot="header">
              <h3 class="card-title title-up">Sign In</h3>

            </template>
            <template>
              <fg-input
                class="no-border input-lg"
                addon-left-icon="now-ui-icons users_circle-08"
                placeholder="E-Mail"
                v-model='form.username'
                @change="inputChanged"
              >
              </fg-input>

              <fg-input
                class="no-border input-lg"
                addon-left-icon="now-ui-icons text_caps-small"
                placeholder="Password"
                type='password' v-model='form.password' @change="inputChanged"
              >
              </fg-input>
              <p id="infoArea">{{info_text}}</p>
            </template>
            <div class="card-footer text-center">
              <n-button v-on:click='signIn' type="neutral" round size="lg">Sign in</n-button>
            </div>

          </card>
        </div>
      </div>
    </div>
    <main-footer></main-footer>
  </div>
</template>
<script>
import { Auth } from 'aws-amplify'
import { AmplifyEventBus } from 'aws-amplify-vue'
import { Card, Button, FormGroupInput } from '@/components';
import MainFooter from '@/layout/MainFooter';
export default {
  name: 'login-page',
  bodyClass: 'login-page',
  components: {
    Card,
    MainFooter,
    [Button.name]: Button,
    [FormGroupInput.name]: FormGroupInput
  },
  data() {
    return {
      form: {
        username: '',
        password: ''
      },
      info_text: ''
    }
  },
  methods: {
    async signIn() {
      const { username, password } = this.form
      await Auth.signIn(username.toLowerCase(), password)
          .catch( err => {
              switch ( err.code ) {
                  case 'UserNotFoundException':
                      // Only here, in .catch error block we actually send a user to sign up
                      alert ("UserNotFoundException")
                      this.info_text = "This user name doesn't exist. Please try again."
                      return false;
                  case 'NotAuthorizedException':
                    alert ("NotAuthorizedException")
                      this.info_text = "Your password was wrong. Please try again."
                      return false;
                  case 'PasswordResetRequiredException':
                      alert ("PasswordResetRequiredException")
                      return false;
                  case 'UserNotConfirmedException':
                      this.info_text = "Your user is not confirmed yet"
                      return false;
                  default:
                      return false;
              }
          })
      AmplifyEventBus.$emit('authState', 'signedIn')
      this.$router.push('/')

    },

    inputChanged: function (event) {
      info_text = '';
    }
  }
};
</script>
<style></style>
